import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
    ComposableMap,
    Geographies,
    Geography,
    Marker,
} from "react-simple-maps";
import ReactDOM from "react-dom";
import balticCountries from "./json/baltic-countries-topo.geojson";
import proj4 from "proj4";

// Definicja układów współrzędnych
proj4.defs(
    "EPSG:3035",
    "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs"
);
proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs +type=crs");

// Funkcja do konwersji współrzędnych
function convertCoordinates(coordinates) {
    if (Array.isArray(coordinates[0])) {
        return coordinates.map((coord) => convertCoordinates(coord));
    }
    return proj4("EPSG:3035", "EPSG:4326", coordinates);
}

// Funkcja do konwersji całego GeoJSON
function convertGeoJSON(geoJSON) {
    const converted = JSON.parse(JSON.stringify(geoJSON));
    converted.features = geoJSON.features.map((feature) => {
        const newFeature = { ...feature };
        if (feature.geometry) {
            const coordinates = feature.geometry.coordinates;
            newFeature.geometry = {
                ...feature.geometry,
                coordinates: convertCoordinates(coordinates),
            };
        }
        return newFeature;
    });
    return converted;
}

const convertedBalticCountries = convertGeoJSON(balticCountries);

document.addEventListener("DOMContentLoaded", function () {
    let modal, modalVideo, currentVideoContext;

    const initImage = () => {
        const images = document.querySelectorAll(".wp-block-custom-image");
        images.forEach((imageContainer) => {
            const hoverBar = imageContainer.querySelector(".hover-bar");

            if (hoverBar) {
                // Ustawienie zmiennych CSS dla hover-bar
                const hoverBarColor = hoverBar.style.getPropertyValue(
                    "--group-hover-color"
                );
                if (hoverBarColor) {
                    hoverBar.style.setProperty(
                        "--hover-bar-color",
                        hoverBarColor
                    );
                }

                imageContainer.addEventListener("mouseenter", function () {
                    const parentSection = this.closest(
                        ".section-block-dynamic"
                    );

                    if (
                        parentSection &&
                        hoverBar.style.getPropertyValue("--group-hover-color")
                    ) {
                        const hoverColor = hoverBar.style.getPropertyValue(
                            "--group-hover-color"
                        );
                        parentSection.style.setProperty(
                            "--group-hover-color",
                            hoverColor
                        );
                        parentSection.classList.add("hover-active");
                    }
                });

                imageContainer.addEventListener("mouseleave", function () {
                    const parentSection = this.closest(
                        ".section-block-dynamic"
                    );
                    if (parentSection) {
                        parentSection.classList.remove("hover-active");
                    }
                });
            }
        });
    };

    // Inicjalizacja modala (popupa)
    const initModalPopup = () => {
        const modalElements = document.querySelectorAll(`.modal-block`);

        modalElements.forEach((el) => {
            const triggerClass = el.dataset.trigger;

            const triggerElements = document.querySelectorAll(
                `.${triggerClass}`
            );

            el.addEventListener(`click`, (e) => {
                if (
                    e.target.classList.contains(`modal-block`) &&
                    e.target.classList.contains(`show`)
                ) {
                    el.classList.toggle(`show`);
                    // Remove modal-active from all triggers when closing modal
                    document
                        .querySelectorAll(".modal-active")
                        .forEach((activeEl) => {
                            activeEl.classList.remove("modal-active");
                        });
                }
            });

            triggerElements.forEach((triggerEl) => {
                triggerEl.addEventListener(`click`, (e) => {
                    e.preventDefault();
                    // Remove modal-active from all elements first
                    document
                        .querySelectorAll(".modal-active")
                        .forEach((activeEl) => {
                            activeEl.classList.remove("modal-active");
                        });

                    // Remove current-menu-item from all menu items
                    document
                        .querySelectorAll(".current-menu-item")
                        .forEach((currentEl) => {
                            currentEl.classList.remove("current-menu-item");
                        });

                    // Close other visible modals
                    document
                        .querySelectorAll(`.modal-block.show`)
                        .forEach(
                            (visibleModal) =>
                                visibleModal !== el &&
                                setTimeout(
                                    () => visibleModal.classList.toggle(`show`),
                                    400
                                )
                        );

                    el.classList.toggle(`show`);
                    // Add modal-active only to the clicked trigger
                    triggerEl.classList.add("modal-active");
                });
            });
        });
    };

    // Inicjalizacja modalu
    const initModal = () => {
        const existingModal = document.querySelector(".video-modal");
        if (existingModal) {
            existingModal.remove();
        }

        modal = document.createElement("div");
        modal.className = "video-modal";
        modal.innerHTML = `
            <button class="video-modal-close">&times;</button>
            <video controls></video>
        `;
        document.body.appendChild(modal);
        modalVideo = modal.querySelector("video");
        const closeButton = modal.querySelector(".video-modal-close");

        const closeModal = () => {
            modal.classList.remove("active");

            if (modalVideo.src) {
                modalVideo.pause();
                modalVideo.removeAttribute("src");
                modalVideo.load();
            }

            document.body.style.overflow = "";

            if (currentVideoContext) {
                currentVideoContext.isPlayButtonClicked = false;
                currentVideoContext = null;
            }
        };

        closeButton.addEventListener("click", closeModal);
        modal.addEventListener("click", (e) => {
            if (e.target === modal) closeModal();
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && modal.classList.contains("active")) {
                closeModal();
            }
        });
    };

    // Inicjalizacja obsługi wideo
    const initVideos = () => {
        const videos = document.querySelectorAll(".wp-block-video video");

        videos.forEach((videoElement) => {
            if (!videoElement || !videoElement.parentElement) return;

            try {
                const videoContext = {
                    element: videoElement,
                    isPlayButtonClicked: false,
                    originalPoster: videoElement.getAttribute("poster") || null,
                    originalSrc: videoElement.src || null,
                    shouldOpenInModal:
                        videoElement.parentElement.hasAttribute(
                            "data-open-modal"
                        ),
                    shouldPlayOnHover:
                        videoElement.parentElement.hasAttribute(
                            "data-play-on-hover"
                        ),
                    shouldPlayOnClick:
                        videoElement.parentElement.hasAttribute(
                            "data-play-on-click"
                        ),
                    parentElement: videoElement.parentElement,
                    isPlaying: false,
                    eventListeners: {},
                };

                const resetOriginalVideo = () => {
                    if (!videoContext || !videoContext.originalPoster) return;

                    try {
                        removeEventListeners(videoContext);

                        const newVideo = document.createElement("video");
                        if (videoContext.originalPoster) {
                            newVideo.setAttribute(
                                "poster",
                                videoContext.originalPoster
                            );
                        }
                        if (videoContext.originalSrc) {
                            newVideo.src = videoContext.originalSrc;
                        }
                        newVideo.muted = true;

                        if (
                            videoContext.element &&
                            videoContext.element.attributes
                        ) {
                            Array.from(videoContext.element.attributes).forEach(
                                (attr) => {
                                    if (
                                        attr &&
                                        attr.name !== "src" &&
                                        attr.name !== "poster"
                                    ) {
                                        newVideo.setAttribute(
                                            attr.name,
                                            attr.value
                                        );
                                    }
                                }
                            );
                        }

                        if (
                            videoContext.element &&
                            videoContext.element.parentNode
                        ) {
                            videoContext.element.parentNode.replaceChild(
                                newVideo,
                                videoContext.element
                            );
                            videoContext.element = newVideo;
                            videoContext.isPlaying = false;
                            videoContext.parentElement.classList.remove(
                                "is-playing"
                            );
                        }

                        setupVideoEventListeners(videoContext);
                    } catch (error) {
                        console.log("Error resetting video:", error);
                    }
                };

                const removeEventListeners = (context) => {
                    if (!context || !context.parentElement) return;

                    try {
                        if (context.eventListeners.click) {
                            context.parentElement.removeEventListener(
                                "click",
                                context.eventListeners.click
                            );
                        }
                        if (context.eventListeners.mouseenter) {
                            context.parentElement.removeEventListener(
                                "mouseenter",
                                context.eventListeners.mouseenter
                            );
                        }
                        if (context.eventListeners.mouseleave) {
                            context.parentElement.removeEventListener(
                                "mouseleave",
                                context.eventListeners.mouseleave
                            );
                        }
                    } catch (error) {
                        console.log("Error removing event listeners:", error);
                    }
                };

                const setupVideoEventListeners = (context) => {
                    if (!context || !context.element || !context.parentElement)
                        return;

                    try {
                        context.element.muted = true;

                        const updatePlayButtonState = () => {
                            if (!context || !context.parentElement) return;

                            if (context.isPlaying) {
                                context.parentElement.classList.add(
                                    "is-playing"
                                );
                                if (context.element) {
                                    context.element.removeAttribute("poster");
                                }
                            } else {
                                context.parentElement.classList.remove(
                                    "is-playing"
                                );
                                if (context.element && context.originalPoster) {
                                    context.element.setAttribute(
                                        "poster",
                                        context.originalPoster
                                    );
                                }
                            }
                        };

                        // Obsługa kliknięcia
                        context.eventListeners.click = function (e) {
                            if (!context || !context.element) return;

                            const isPlayButton =
                                e.target.closest(".show-play-button");

                            if (context.shouldPlayOnClick) {
                                e.preventDefault();
                                if (!context.isPlaying) {
                                    context.element.removeAttribute("poster");
                                    context.element
                                        .play()
                                        .then(() => {
                                            context.isPlaying = true;
                                            updatePlayButtonState();
                                        })
                                        .catch((error) => {
                                            console.log(
                                                "Playback failed:",
                                                error
                                            );
                                        });
                                } else {
                                    context.element.pause();
                                    context.isPlaying = false;
                                    updatePlayButtonState();
                                    resetOriginalVideo();
                                }
                                return;
                            }

                            if (isPlayButton && context.shouldOpenInModal) {
                                e.preventDefault();
                                context.isPlayButtonClicked = true;

                                if (context.isPlaying) {
                                    resetOriginalVideo();
                                }

                                if (modalVideo && modalVideo.src) {
                                    modalVideo.pause();
                                    modalVideo.removeAttribute("src");
                                    modalVideo.load();
                                }

                                currentVideoContext = context;
                                if (modalVideo && context.originalSrc) {
                                    modalVideo.src = context.originalSrc;
                                    modalVideo.muted = false;
                                    if (modal) {
                                        modal.classList.add("active");
                                        document.body.style.overflow = "hidden";
                                    }
                                    modalVideo.play().catch((error) => {
                                        console.log(
                                            "Modal playback failed:",
                                            error
                                        );
                                    });
                                }
                            }
                        };

                        // Obsługa najechania myszką
                        if (context.shouldPlayOnHover) {
                            context.eventListeners.mouseenter = function () {
                                if (
                                    !context ||
                                    !context.element ||
                                    context.isPlayButtonClicked ||
                                    context.isPlaying
                                )
                                    return;

                                context.element.removeAttribute("poster");
                                context.element
                                    .play()
                                    .then(() => {
                                        context.isPlaying = true;
                                        updatePlayButtonState();
                                    })
                                    .catch((error) => {
                                        console.log("Playback failed:", error);
                                    });
                            };

                            context.eventListeners.mouseleave = function () {
                                if (
                                    !context ||
                                    (context.isPlayButtonClicked &&
                                        context.shouldOpenInModal)
                                )
                                    return;
                                resetOriginalVideo();
                                context.isPlaying = false;
                                updatePlayButtonState();
                            };
                        }

                        // Dodawanie event listenerów
                        if (
                            context.parentElement &&
                            context.eventListeners.click
                        ) {
                            context.parentElement.addEventListener(
                                "click",
                                context.eventListeners.click
                            );
                        }

                        if (
                            context.shouldPlayOnHover &&
                            context.parentElement
                        ) {
                            if (context.eventListeners.mouseenter) {
                                context.parentElement.addEventListener(
                                    "mouseenter",
                                    context.eventListeners.mouseenter
                                );
                            }
                            if (context.eventListeners.mouseleave) {
                                context.parentElement.addEventListener(
                                    "mouseleave",
                                    context.eventListeners.mouseleave
                                );
                            }
                        }
                    } catch (error) {
                        console.log(
                            "Error setting up video event listeners:",
                            error
                        );
                    }
                };

                setupVideoEventListeners(videoContext);
            } catch (error) {
                console.log("Error initializing video:", error);
            }
        });
    };

    // Inicjalizacja sliderów
    const initSliders = () => {
        const sliders = document.querySelectorAll(
            ".wp-block-kamikaze-slider-block"
        );

        sliders.forEach((slider) => {
            // Pobieramy wartości z data-atrybutów
            const slidesPerView = parseInt(slider.dataset.slidesPerView) || 3;
            const slidesPerViewTablet =
                parseInt(slider.dataset.slidesPerViewTablet) || 2;
            const slidesPerViewMobile =
                parseInt(slider.dataset.slidesPerViewMobile) || 1;
            const spaceBetween = parseInt(slider.dataset.spaceBetween) || 32;
            const spaceBetweenTablet =
                parseInt(slider.dataset.spaceBetweenTablet) || 24;
            const spaceBetweenMobile =
                parseInt(slider.dataset.spaceBetweenMobile) || 16;
            const showNavigation = slider.dataset.showNavigation === "true";
            const showNavigationTablet =
                slider.dataset.showNavigationTablet === "true";
            const showNavigationMobile =
                slider.dataset.navigationMobile === "true";
            const showPagination = slider.dataset.showPagination === "true";
            const showPaginationTablet =
                slider.dataset.showPaginationTablet === "true";
            const showPaginationMobile =
                slider.dataset.showPaginationMobile === "true";

            const swiperInstance = new Swiper(slider, {
                modules: [Navigation, Pagination],
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                init: false,
                breakpoints: {
                    320: {
                        slidesPerView: slidesPerViewMobile,
                        spaceBetween: spaceBetweenMobile,
                        navigation: {
                            enabled: showNavigationMobile,
                        },
                        pagination: {
                            enabled: showPaginationMobile,
                        },
                    },
                    768: {
                        slidesPerView: slidesPerViewTablet,
                        spaceBetween: spaceBetweenTablet,
                        navigation: {
                            enabled: showNavigationTablet,
                        },
                        pagination: {
                            enabled: showPaginationTablet,
                        },
                    },
                    1024: {
                        slidesPerView: slidesPerView,
                        spaceBetween: spaceBetween,
                        navigation: {
                            enabled: showNavigation,
                        },
                        pagination: {
                            enabled: showPagination,
                        },
                    },
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });

            // Inicjalizacja Swipera
            swiperInstance.init();
        });
    };

    // Inicjalizacja obsługi wideo
    const initVideoScroll = () => {
        const videoContainer = document.querySelectorAll(
            ".wp-block-video.animate-on-scroll"
        );

        function isElementInView(element) {
            const rect = element.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            return rect.top <= windowHeight && rect.bottom >= 0;
        }

        function getScrollProgress(element) {
            const rect = element.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const elementHeight = rect.height;
            const progress = (windowHeight - rect.top) / elementHeight;
            return Math.min(Math.max(progress, 0), 1);
        }

        window.addEventListener("scroll", () => {
            videoContainer.forEach((container) => {
                const video = container.querySelector("video");
                if (!video || !isElementInView(container)) return;

                const scrollProgress = getScrollProgress(container);
                const videoDuration = video.duration;
                if (!isNaN(videoDuration)) {
                    video.currentTime = scrollProgress * videoDuration;
                }
            });
        });
    };

    // Inicjalizacja menu
    const initMenus = () => {
        const menus = document.querySelectorAll(".menu-block");

        const handleMobileMenu = (menuBlock) => {
            const navigation = menuBlock.querySelector(".menu-navigation");
            const mobileBreakpoint =
                parseInt(menuBlock.dataset.mobileBreakpoint) || 768;
            const mobileBehavior =
                menuBlock.dataset.mobileBehavior || "hamburger";

            if (window.innerWidth <= mobileBreakpoint) {
                navigation.classList.add("mobile");

                // Obsługa dropdown
                if (mobileBehavior === "dropdown") {
                    const dropdownItems = navigation.querySelectorAll(
                        ".menu-item-has-children"
                    );
                    dropdownItems.forEach((item) => {
                        if (!item.dataset.hasDropdownListener) {
                            item.dataset.hasDropdownListener = true;
                            item.addEventListener("click", (e) => {
                                e.preventDefault();
                                item.classList.toggle("active");
                            });
                        }
                    });
                }

                // Obsługa akordeonu
                if (mobileBehavior === "accordion") {
                    const accordionItems = navigation.querySelectorAll(
                        ".menu-item-has-children"
                    );
                    accordionItems.forEach((item) => {
                        if (!item.dataset.hasAccordionListener) {
                            item.dataset.hasAccordionListener = true;
                            item.addEventListener("click", (e) => {
                                e.preventDefault();
                                const wasActive =
                                    item.classList.contains("active");
                                accordionItems.forEach((i) =>
                                    i.classList.remove("active")
                                );
                                if (!wasActive) {
                                    item.classList.add("active");
                                }
                            });
                        }
                    });
                }
            } else {
                navigation.classList.remove("mobile", "active");
                const toggle = menuBlock.querySelector(".mobile-menu-toggle");
                if (toggle) toggle.remove();
            }
        };

        const setupMenuAnimation = (menuBlock) => {
            const navigation = menuBlock.querySelector(".menu-navigation");
            if (!navigation) return;

            const animation = navigation.dataset.animation;
            const animationDuration =
                parseFloat(navigation.dataset.animationDuration) || 0.3;
            const menuItems = navigation.querySelectorAll(".menu-item");

            if (animation !== "none") {
                menuItems.forEach((item) => {
                    item.style.transition = `all ${animationDuration}s`;
                });
            }

            // Obsługa hover efektów
            const hoverColor = navigation.dataset.hoverColor;
            const backgroundColor =
                window.getComputedStyle(navigation).backgroundColor;

            menuItems.forEach((item) => {
                item.addEventListener("mouseenter", () => {
                    if (hoverColor) item.style.backgroundColor = hoverColor;
                });
                item.addEventListener("mouseleave", () => {
                    item.style.backgroundColor = backgroundColor;
                });
            });
        };

        const setupStickyMenu = (menuBlock) => {
            const navigation = menuBlock.querySelector(".menu-navigation");
            const actions = menuBlock.querySelector(".menu-actions");

            if (
                !navigation ||
                !actions ||
                menuBlock.dataset.isSticky !== "true"
            )
                return;

            const stickyOffset = parseInt(menuBlock.dataset.stickyOffset) || 0;
            const stickyBgColor = actions.dataset.stickyBackgroundColor;
            const stickyHeight = actions.dataset.stickyHeight;
            const stickyWidth = actions.dataset.stickyWidth;
            const showProgressBar = actions.dataset.showProgressBar === "true";
            const progressBarColor = actions.dataset.progressBarColor;
            const progressBarHeight =
                parseInt(actions.dataset.progressBarHeight) || 4;

            // Początkowo ukryj menu-actions
            actions.style.display = "none";

            // Dodaj progress bar jeśli jest włączony
            let progressBar;
            if (showProgressBar) {
                progressBar = document.createElement("div");
                progressBar.className = "menu-progress-bar";
                progressBar.style.cssText = `
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 0%;
                    height: ${progressBarHeight}px;
                    background-color: ${progressBarColor};
                    transition: width 0.1s ease-out;
                `;
                actions.appendChild(progressBar);
            }

            window.addEventListener("scroll", () => {
                const shouldBeSticky = window.pageYOffset > stickyOffset;

                if (shouldBeSticky) {
                    navigation.style.display = "none";
                    actions.style.display = "block";
                    if (stickyBgColor)
                        actions.style.backgroundColor = stickyBgColor;
                    if (stickyHeight) actions.style.height = stickyHeight;
                    if (stickyWidth) actions.style.width = stickyWidth;

                    // Aktualizuj progress bar
                    if (showProgressBar && progressBar) {
                        const windowHeight =
                            document.documentElement.scrollHeight -
                            window.innerHeight;
                        const scrolled = window.pageYOffset;
                        const progress = (scrolled / windowHeight) * 100;
                        progressBar.style.width = `${progress}%`;
                    }
                } else {
                    navigation.style.display = "block";
                    actions.style.display = "none";
                }
            });
        };

        // Inicjalizacja dla każdego menu
        menus.forEach((menuBlock) => {
            // Obsługa menu mobilnego
            handleMobileMenu(menuBlock);
            window.addEventListener("resize", () =>
                handleMobileMenu(menuBlock)
            );

            // Obsługa animacji i efektów hover
            setupMenuAnimation(menuBlock);

            // Obsługa sticky menu
            setupStickyMenu(menuBlock);
        });
    };

    const initArticleBarOnButtonHover = () => {
        const norbalButtons = document.querySelectorAll(".norbal-button");

        norbalButtons.forEach((button, index) => {
            button.addEventListener(
                "mouseover",
                () => {
                    document.querySelector(
                        ".norbal-article-bar.bar-" + (index + 1)
                    ).style.width = 60 + "%";
                },
                false
            );

            button.addEventListener(
                "mouseout",
                () => {
                    document.querySelector(
                        ".norbal-article-bar.bar-" + (index + 1)
                    ).style.width = 0 + "%";
                },
                false
            );
        });
    };

    // Inicjalizacja mapy bałtyckiej
    const initBalticMap = () => {
        const mapElements = document.querySelectorAll(".map-block");

        mapElements.forEach((element) => {
            try {
                const locations = JSON.parse(element.dataset.locations || "[]");
                const selectedCountries = JSON.parse(
                    element.dataset.selectedCountries || "[]"
                );
                const countryColors = JSON.parse(
                    element.dataset.countryColors || "{}"
                );
                const mapRotation = JSON.parse(
                    element.dataset.rotation || "[0,0,0]"
                );
                const showCityLabels =
                    element.dataset.showCityLabels === "true";

                // Dodajemy parsowanie nowych stylów
                const markerStyles = JSON.parse(
                    element.dataset.markerStyles ||
                        JSON.stringify({
                            office: {
                                color: "#007cba",
                                size: 4,
                                strokeWidth: 2,
                                strokeColor: "#fff",
                            },
                            factory: {
                                color: "#FF5733",
                                size: 4,
                                strokeWidth: 2,
                                strokeColor: "#fff",
                            },
                        })
                );

                const labelStyles = JSON.parse(
                    element.dataset.labelStyles ||
                        JSON.stringify({
                            fontSize: 9,
                            color: "#333",
                            offset: 20,
                        })
                );

                // Pobieranie ustawień z data-attributes
                const settings = {
                    scale: parseInt(element.dataset.scale) || 200,
                    centerLat: parseFloat(element.dataset.centerLat) || 57,
                    centerLng: parseFloat(element.dataset.centerLng) || 24,
                    rotation: mapRotation,
                };

                const BalticMapComponent = () => (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            position: "relative",
                        }}
                    >
                        <ComposableMap
                            projection="geoMercator"
                            projectionConfig={{
                                center: [
                                    settings.centerLng,
                                    settings.centerLat,
                                ],
                                scale: settings.scale * 0.85,
                                rotate: settings.rotation,
                            }}
                            style={{
                                width: "100%",
                                height: "100%",
                                position: "absolute",
                                top: 0,
                                left: 0,
                            }}
                        >
                            <Geographies geography={convertedBalticCountries}>
                                {({ geographies }) =>
                                    geographies
                                        .filter((geo) =>
                                            selectedCountries.includes(
                                                geo.properties.ISO3_CODE.toLowerCase()
                                            )
                                        )
                                        .map((geo) => (
                                            <Geography
                                                key={geo.rsmKey}
                                                geography={geo}
                                                style={{
                                                    default: {
                                                        fill:
                                                            countryColors[
                                                                geo.properties
                                                                    .ISO3_CODE
                                                            ] || "#007cba",
                                                        outline: "none",
                                                    },
                                                    hover: {
                                                        fill: countryColors[
                                                            geo.properties
                                                                .ISO3_CODE
                                                        ]
                                                            ? `${
                                                                  countryColors[
                                                                      geo
                                                                          .properties
                                                                          .ISO3_CODE
                                                                  ]
                                                              }dd`
                                                            : "#006ba1",
                                                        outline: "none",
                                                    },
                                                    pressed: {
                                                        fill: countryColors[
                                                            geo.properties
                                                                .ISO3_CODE
                                                        ]
                                                            ? `${
                                                                  countryColors[
                                                                      geo
                                                                          .properties
                                                                          .ISO3_CODE
                                                                  ]
                                                              }bb`
                                                            : "#005a88",
                                                        outline: "none",
                                                    },
                                                }}
                                            />
                                        ))
                                }
                            </Geographies>

                            {locations.map((location) => (
                                <Marker
                                    key={location.id}
                                    coordinates={location.coordinates}
                                >
                                    <g
                                        style={{
                                            cursor:
                                                location.cursor || "default",
                                            pointerEvents: "all",
                                        }}
                                    >
                                        <circle
                                            className={location.className || ""}
                                            r={markerStyles[location.type].size}
                                            fill={
                                                markerStyles[location.type]
                                                    .color
                                            }
                                            stroke={
                                                markerStyles[location.type]
                                                    .strokeColor
                                            }
                                            strokeWidth={
                                                markerStyles[location.type]
                                                    .strokeWidth
                                            }
                                        />
                                        {showCityLabels && (
                                            <text
                                                textAnchor="middle"
                                                y={labelStyles.offset}
                                                style={{
                                                    fontFamily: "Arial",
                                                    fontSize: `${labelStyles.fontSize}px`,
                                                    fill: labelStyles.color,
                                                    fontWeight: "bold",
                                                    textShadow:
                                                        "1px 1px 1px rgba(255,255,255,0.5)",
                                                    cursor:
                                                        location.cursor ||
                                                        "default",
                                                    pointerEvents: "all",
                                                }}
                                            >
                                                {location.city}
                                            </text>
                                        )}
                                    </g>
                                </Marker>
                            ))}
                        </ComposableMap>
                    </div>
                );

                ReactDOM.render(<BalticMapComponent />, element);
            } catch (error) {
                console.error("Error initializing Baltic map:", error);
            }
        });
    };

    const initContactForm = () => {
        const forms = document.querySelectorAll(".contact-form");
        if (!forms.length) return;

        const showMessage = (form, message, type = "error") => {
            const container = form.querySelector(".form-message-container");
            const messageDiv = document.createElement("div");
            messageDiv.className = `form-message ${type}`;
            messageDiv.textContent = message;

            container.appendChild(messageDiv);
            setTimeout(() => messageDiv.remove(), 5000);
        };

        forms.forEach((form) => {
            const inputs = form.querySelectorAll(".form-control");
            const fileInput = form.querySelector('input[type="file"]');
            const selectedFilesDiv = form.querySelector(".selected-files");
            const consents = form.querySelectorAll(".consent-item");
            const attachmentsGroup = form.querySelector(".attachments-group");

            // Zastosuj style dla pól formularza
            form.querySelectorAll(".form-group").forEach((group) => {
                const label = group.querySelector("label");
                if (label) {
                    const labelFontSize = label.dataset.fontSize;
                    const labelColor = label.dataset.color;

                    if (labelFontSize) {
                        label.style.fontSize = labelFontSize;
                    }
                    if (labelColor) {
                        label.style.color = labelColor;
                    }
                }
            });

            // Zastosuj style dla sekcji załączników
            if (attachmentsGroup) {
                const fileInput = attachmentsGroup.querySelector(
                    '.file-input-container input[type="file"]'
                );
                const attachmentLabel = attachmentsGroup.querySelector("label");
                const infoText = attachmentsGroup.querySelector("small");

                // Pobierz wszystkie style z data-attributes
                const buttonStyles = {
                    "--button-font-size":
                        attachmentsGroup.dataset.buttonFontSize,
                    "--button-text-color":
                        attachmentsGroup.dataset.buttonTextColor,
                    "--button-bg-color": attachmentsGroup.dataset.buttonBgColor,
                    "--button-padding-y":
                        attachmentsGroup.dataset.buttonPaddingY,
                    "--button-padding-x":
                        attachmentsGroup.dataset.buttonPaddingX,
                    "--button-border-radius":
                        attachmentsGroup.dataset.buttonBorderRadius,
                    "--button-border-width":
                        attachmentsGroup.dataset.buttonBorderWidth,
                    "--button-border-color":
                        attachmentsGroup.dataset.buttonBorderColor,
                    "--button-border-style":
                        attachmentsGroup.dataset.buttonBorderStyle,
                    "--button-margin-top":
                        attachmentsGroup.dataset.buttonMarginTop,
                    "--button-margin-bottom":
                        attachmentsGroup.dataset.buttonMarginBottom,
                };

                // Zastosuj style jako CSS variables
                Object.entries(buttonStyles).forEach(([key, value]) => {
                    if (value) {
                        attachmentsGroup.style.setProperty(key, value);
                    }
                });

                // Style tekstu informacyjnego
                if (infoText) {
                    const infoFontSize = infoText.dataset.infoFontSize;
                    const infoColor = infoText.dataset.color;

                    if (infoFontSize) infoText.style.fontSize = infoFontSize;
                    if (infoColor) infoText.style.color = infoColor;
                }
            }

            // Zastosuj style dla zgód
            consents.forEach((consent) => {
                const label = consent.querySelector("label span");
                if (label) {
                    const fontSize = consent.dataset.fontSize;
                    const color = consent.dataset.color;

                    if (fontSize) label.style.fontSize = fontSize;
                    if (color) label.style.color = color;
                }
            });

            // Obsługa walidacji
            const validateField = (input) => {
                const value = input.value.trim();
                const feedback =
                    input.parentElement.querySelector(".form-feedback");

                input.classList.remove("is-valid", "is-invalid");
                if (feedback) {
                    feedback.classList.remove(
                        "valid-feedback",
                        "invalid-feedback"
                    );
                    feedback.textContent = "";
                }

                if (!value && input.required) {
                    input.classList.add("is-invalid");
                    if (feedback) {
                        feedback.classList.add("invalid-feedback");
                        feedback.textContent = "To pole jest wymagane";
                    }
                    return false;
                }

                if (input.type === "email" && value) {
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(value)) {
                        input.classList.add("is-invalid");
                        if (feedback) {
                            feedback.classList.add("invalid-feedback");
                            feedback.textContent =
                                "Wprowadź poprawny adres email";
                        }
                        return false;
                    }
                }

                // Dla poprawnie wypełnionego pola dodajemy tylko klasę is-valid
                input.classList.add("is-valid");
                return true;
            };

            // Walidacja podczas wpisywania
            inputs.forEach((input) => {
                ["input", "blur"].forEach((event) => {
                    input.addEventListener(event, () => validateField(input));
                });
            });

            // Obsługa załączników
            if (fileInput && selectedFilesDiv) {
                fileInput.addEventListener("change", (e) => {
                    const files = Array.from(e.target.files);
                    const fileContainer = fileInput.closest(
                        ".file-input-container"
                    );

                    if (files.length > 0) {
                        // Ukryj kontener z inputem
                        fileContainer.style.display = "none";

                        // Pokaż wybrane pliki
                        selectedFilesDiv.innerHTML = files
                            .map(
                                (file) => `
                                <div class="file-item">
                                    <span class="file-name">${file.name}</span>
                                    <span class="remove-file">×</span>
                                </div>
                            `
                            )
                            .join("");

                        // Obsługa usuwania plików
                        selectedFilesDiv
                            .querySelectorAll(".remove-file")
                            .forEach((button) => {
                                button.addEventListener("click", function () {
                                    const fileItem = this.closest(".file-item");
                                    const fileName =
                                        fileItem.querySelector(
                                            ".file-name"
                                        ).textContent;
                                    const newFiles = Array.from(
                                        fileInput.files
                                    ).filter((f) => f.name !== fileName);

                                    // Stwórz nowy obiekt FileList
                                    const dataTransfer = new DataTransfer();
                                    newFiles.forEach((file) =>
                                        dataTransfer.items.add(file)
                                    );
                                    fileInput.files = dataTransfer.files;

                                    // Jeśli nie ma więcej plików, pokaż ponownie przycisk wyboru
                                    if (newFiles.length === 0) {
                                        fileContainer.style.display = "flex";
                                        selectedFilesDiv.innerHTML = "";
                                    } else {
                                        fileItem.remove();
                                    }
                                });
                            });
                    }
                });
            }

            // Obsługa wysyłki formularza
            form.addEventListener("submit", (e) => {
                e.preventDefault();

                // Walidacja wszystkich pól
                let isValid = true;
                inputs.forEach((input) => {
                    if (!validateField(input)) {
                        isValid = false;
                    }
                });

                if (!isValid) {
                    showMessage(
                        form,
                        "Proszę wypełnić wszystkie wymagane pola poprawnie"
                    );
                    return;
                }

                const submitBtn = form.querySelector(".wp-block-button__link");
                if (!submitBtn) return;

                const originalText = submitBtn.textContent;
                submitBtn.textContent = "Wysyłanie...";
                submitBtn.disabled = true;

                const formData = new FormData(form);
                const payload = {
                    firstName: formData.get("name").split(" ")[0] || "",
                    lastName:
                        formData.get("name").split(" ").slice(1).join(" ") ||
                        "",
                    email: formData.get("email") || "",
                    contactMessage: formData.get("message") || "",
                    attachments: [],
                };

                const apiUrl =
                    form.dataset.endpoint === "PROD"
                        ? "https://apishop-eu-west-1.danaccess.net/sm-contact-form-api-v1/api/contacts"
                        : "https://apishop-eu-west-1-test.danaccess.net/ssm-contact-form-api-v1/api/contacts";

                const xhr = new XMLHttpRequest();
                xhr.open("POST", apiUrl, true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.setRequestHeader("x-api-key", "1");
                xhr.setRequestHeader("source-uri", "1");

                xhr.onload = function () {
                    if (xhr.status === 200) {
                        try {
                            const response = JSON.parse(xhr.responseText);
                            if (response.requestId) {
                                form.reset();
                                showMessage(
                                    form,
                                    "Wiadomość została wysłana pomyślnie!",
                                    "success"
                                );
                                inputs.forEach((input) => {
                                    input.classList.remove(
                                        "is-valid",
                                        "is-invalid"
                                    );
                                    input.parentElement.querySelector(
                                        ".form-feedback"
                                    ).textContent = "";
                                });
                                if (selectedFilesDiv) {
                                    selectedFilesDiv.innerHTML = "";
                                }
                            } else {
                                showMessage(
                                    form,
                                    "Nie otrzymano potwierdzenia wysłania formularza"
                                );
                            }
                        } catch (e) {
                            showMessage(
                                form,
                                "Błąd podczas przetwarzania odpowiedzi"
                            );
                        }
                    } else {
                        showMessage(
                            form,
                            "Wystąpił błąd podczas wysyłania formularza"
                        );
                    }
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalText;
                };

                xhr.onerror = function () {
                    showMessage(form, "Błąd połączenia z serwerem");
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalText;
                };

                xhr.send(JSON.stringify(payload));
            });
        });
    };

    // Obsługa przycisku open-menu
    const initOpenMenuButton = () => {
        const openMenuButtons = document.querySelectorAll(".open-menu");

        openMenuButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            });
        });
    };

    // Obsługa blokowania scrolla dla modali
    const initModalScrollLock = () => {
        const checkModalState = () => {
            const anyModalVisible = document.querySelector(
                ".wp-block-kamikaze-modal-menu.show"
            );
            document.body.style.overflow = anyModalVisible ? "hidden" : "";
        };

        const modalObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "class"
                ) {
                    const modal = mutation.target;
                    if (
                        modal.classList.contains("wp-block-kamikaze-modal-menu")
                    ) {
                        checkModalState();
                    }
                }
            });
        });

        const modals = document.querySelectorAll(
            ".wp-block-kamikaze-modal-menu"
        );
        modals.forEach((modal) => {
            modalObserver.observe(modal, { attributes: true });
        });

        // Sprawdź początkowy stan
        checkModalState();
    };

    // Inicjalizacja wszystkich funkcjonalności
    initImage();
    initModal();
    initVideos();
    initSliders();
    initVideoScroll();
    initMenus();
    initArticleBarOnButtonHover();
    initBalticMap();
    initModalPopup();
    initContactForm();
    initOpenMenuButton();
    initModalScrollLock();
});
